(function () {
  const mount = document.getElementById("hubMount");
  if (!mount) return;

  // 1) HTML injecté dans la page Shopify
  mount.innerHTML = `
    <div class="sdd-hub-root" id="sddHubRoot">
      <header class="sdd-topbar">
        <div class="sdd-brand">
          <div class="sdd-badge">🪄</div>
          <div>
            <h1>Salle sur Demande</h1>
            <p>Outils de gestion de classe — multi-fenêtres</p>
          </div>
        </div>

        <div class="sdd-controls">
          <div class="sdd-search" title="Rechercher un outil (dans le menu)">
            🔎
            <input id="searchTop" type="text" placeholder="Rechercher un outil…" autocomplete="off" />
          </div>
          <button id="btn-arrange" title="Réorganiser les fenêtres">Organiser</button>
        </div>

        <div class="sdd-btns">
          <button id="btn-minimize-all" title="Mettre tous les outils en suspend">Tout minimiser</button>
          <button id="btn-close-all" title="Fermer tous les outils">Tout fermer</button>
        </div>
      </header>

      <main class="sdd-app" id="appRoot">
        <aside class="sdd-panel" aria-label="Menu des outils">
          <div class="sdd-panel-header">
            <div class="sdd-panel-title">
              <div class="sdd-dot">📚</div>
              <div class="sdd-txt">
                <h2>Outils disponibles</h2>
                <p>Réduire le menu pour un rendu épuré</p>
              </div>
            </div>
            <button id="btn-toggle-panel" class="sdd-panel-toggle" title="Réduire / agrandir le menu (raccourci : M)" aria-label="Réduire le menu">⇤</button>
          </div>

          <div class="sdd-search-inline" title="Rechercher un outil">
            🔎
            <input id="searchSide" type="text" placeholder="Rechercher…" autocomplete="off" />
          </div>

          <p class="sdd-hint">
            Clique sur un outil pour l’ouvrir.<br/>
            <b>Minimiser</b> = suspendre visuellement (dock). <b>Fermer</b> = retirer la fenêtre.
          </p>

          <div id="grid" class="sdd-grid"></div>
        </aside>

        <section class="sdd-stage" id="stage">
          <div class="sdd-dock" id="dock" aria-label="Dock des outils minimisés"></div>
        </section>
      </main>
    </div>
  `;

  // ====== CONFIG OUTILS ======
  const TOOLS = [
    {
      id: "livre-plume",
      name: "Le livre désignateur et la plume de la répartition",
      icon: "📜",
      desc: "Tirage / répartition d'élèves — pour sélectionner ou répartir.",
      url: "https://lecolibrinumerique.github.io/Livre-et-plume/"
    },
    {
      id: "miroir-liavart",
      name: "Le Miroir du Liavart",
      icon: "🪞",
      desc: "Affichage des conditions de travail et objectifs",
      url: "https://lecolibrinumerique.github.io/Miroir-du-Liavart/"
    },
    {
      id: "phenix",
      name: "Le Phénix surveillant",
      icon: "🔥",
      desc: "Sonomètre — visualisation simple du bruit.",
      url: "https://lecolibrinumerique.github.io/Ph-nix/"
      // Si le micro reste bloqué dans Shopify malgré allow=, décommente :
      // ,openMode: "tab"
    },
        {
      id: "epouvantard",
      name: "L’Épouvantard",
      icon: "👻",
      desc: "Séance de rappel/Billet de sortie",
      url: "https://lecolibrinumerique.github.io/epouvantard/"
    },
    {
      id: "retourneur-temps",
      name: "Le Retourneur de temps",
      icon: "⏳",
      desc: "Minuteur & chronomètre — pour rythmer les activités.",
      url: "https://lecolibrinumerique.github.io/Minuteur-et-chronom-tre/"
    },
        {
      id: "generateur-de-csv",
      name: "Le générateur de CSV magique",
      icon: "📊",
      desc: "Exportez vos listes d'élèves, vos questions et QCM.",
      url: "https://lecolibrinumerique.github.io/G-n-rateur-de-CSV/"
    },
    {
      id: "tableau-magique",
      name: "Le Tableau magique",
      icon: "🧠",
      desc: "Tableau / affichage — support visuel en classe.",
      url: "https://lecolibrinumerique.github.io/Tableau/"
    }
  ];

  // ====== ELEMENTS ======
  const appRoot = document.getElementById("appRoot");
  const grid = document.getElementById("grid");
  const stage = document.getElementById("stage");
  const dock = document.getElementById("dock");

  const searchTop = document.getElementById("searchTop");
  const searchSide = document.getElementById("searchSide");

  const btnTogglePanel = document.getElementById("btn-toggle-panel");
  const btnArrange = document.getElementById("btn-arrange");
  const btnCloseAll = document.getElementById("btn-close-all");
  const btnMinAll = document.getElementById("btn-minimize-all");

  const windows = new Map(); // toolId -> { el, minimized, max }
  let zTop = 20;

  // ====== HELPERS ======
  function el(tag, attrs={}, children=[]) {
    const node = document.createElement(tag);
    for (const [k,v] of Object.entries(attrs)) {
      if (k === "class") node.className = v;
      else if (k === "html") node.innerHTML = v;
      else if (k.startsWith("on") && typeof v === "function") node.addEventListener(k.slice(2), v);
      else node.setAttribute(k, v);
    }
    for (const c of children) node.appendChild(c);
    return node;
  }

  function bringToFront(winEl){
    zTop += 1;
    winEl.style.zIndex = zTop;
  }

  // ====== MENU (COLLAPSE) ======
  function setPanelCollapsed(collapsed){
    if (collapsed) appRoot.classList.add("sdd-panel-collapsed");
    else appRoot.classList.remove("sdd-panel-collapsed");

    btnTogglePanel.innerText = collapsed ? "⇥" : "⇤";
    btnTogglePanel.setAttribute("aria-label", collapsed ? "Agrandir le menu" : "Réduire le menu");
    btnTogglePanel.title = collapsed ? "Agrandir le menu (raccourci : M)" : "Réduire le menu (raccourci : M)";

    setTimeout(tileWindows, 50);
  }

  btnTogglePanel.addEventListener("click", ()=>{
    setPanelCollapsed(!appRoot.classList.contains("sdd-panel-collapsed"));
  });

  window.addEventListener("keydown", (e)=>{
    const tag = (e.target && e.target.tagName) ? e.target.tagName.toLowerCase() : "";
    const typing = tag === "input" || tag === "textarea";
    if (typing) return;
    if (e.key.toLowerCase() === "m"){
      e.preventDefault();
      setPanelCollapsed(!appRoot.classList.contains("sdd-panel-collapsed"));
    }
  });

  // ====== TILES ======
  function renderTiles(list){
    grid.innerHTML = "";
    list.forEach(t => {
      const tile = el("div", { class: "sdd-tile", role:"button", tabindex:"0" }, [
        el("div", { class: "sdd-ico", "aria-hidden":"true", html: t.icon }),
        el("div", {}, [
          el("h3", { html: t.name }),
          el("p", { html: t.desc })
        ])
      ]);
      tile.addEventListener("click", () => openTool(t.id));
      tile.addEventListener("keydown", (e)=>{ if(e.key==="Enter"||e.key===" "){ e.preventDefault(); openTool(t.id); } });
      grid.appendChild(tile);
    });
  }

  function applySearch(qRaw){
    const q = (qRaw || "").trim().toLowerCase();
    const filtered = !q ? TOOLS : TOOLS.filter(t =>
      t.name.toLowerCase().includes(q) ||
      t.desc.toLowerCase().includes(q)
    );
    renderTiles(filtered);
  }

  searchTop.addEventListener("input", ()=>{
    searchSide.value = searchTop.value;
    applySearch(searchTop.value);
  });
  searchSide.addEventListener("input", ()=>{
    searchTop.value = searchSide.value;
    applySearch(searchSide.value);
  });

  // ====== WINDOWS ======
  function openTool(toolId){
    const tool = TOOLS.find(t => t.id === toolId);
    if (!tool) return;

    // Option ultra fiable pour micro/cam : ouvrir en nouvel onglet
    if (tool.openMode === "tab") {
      window.open(tool.url, "_blank", "noopener,noreferrer");
      return;
    }

    if (windows.has(toolId)){
      const w = windows.get(toolId);
      if (w.minimized) restoreTool(toolId);
      bringToFront(w.el);
      return;
    }

    const win = createWindow(tool);
    windows.set(toolId, { el: win, minimized:false, max:false });
    stage.appendChild(win);
    bringToFront(win);

    tileWindows();
    refreshDock();
  }

  function createWindow(tool){
    const win = el("div", { class:"sdd-window", "data-tool": tool.id });

    win.style.left = "60px";
    win.style.top = "80px";
    win.style.width = "680px";
    win.style.height = "520px";

    const head = el("div", { class:"sdd-w-head" });
    const title = el("div", { class:"sdd-w-title" }, [
      el("div", { class:"mini", html: tool.icon }),
      el("span", { title: tool.name, html: tool.name })
    ]);

    const btnMin = el("button", { class:"sdd-iconbtn", title:"Mettre en suspend (minimiser)", "aria-label":"Minimiser", html:"—" });
    const btnMax = el("button", { class:"sdd-iconbtn", title:"Agrandir / Réduire", "aria-label":"Agrandir", html:"▢" });
    const btnClose = el("button", { class:"sdd-iconbtn", title:"Fermer", "aria-label":"Fermer", html:"✕" });

    const actions = el("div", { class:"sdd-w-actions" }, [btnMin, btnMax, btnClose]);

    head.appendChild(title);
    head.appendChild(actions);

    const body = el("div", { class:"sdd-w-body" });

    // IMPORTANT : délégation micro à l'iframe
    const frame = el("iframe", {
      src: tool.url,
      title: tool.name,
      loading: "lazy",
      referrerpolicy: "no-referrer",
      allow: "microphone *; fullscreen *",
      allowfullscreen: "true"
    });

    const blocked = el("div", { class:"sdd-blocked", style:"display:none;" }, [
      el("h4", { html:"Impossible d’afficher l’outil dans la fenêtre." }),
      el("p", { html:"Selon les réglages de sécurité du site de l’outil, l’intégration en iframe peut être refusée. Tu peux l’ouvrir dans un nouvel onglet." }),
      el("a", { href: tool.url, target:"_blank", rel:"noopener noreferrer", html:"Ouvrir dans un nouvel onglet" })
    ]);

    body.appendChild(frame);
    body.appendChild(blocked);

    win.appendChild(head);
    win.appendChild(body);

    let loaded = false;
    const timer = setTimeout(() => { if (!loaded) blocked.style.display = "flex"; }, 3500);
    frame.addEventListener("load", () => { loaded = true; clearTimeout(timer); blocked.style.display = "none"; });

    win.addEventListener("mousedown", () => bringToFront(win));
    btnClose.addEventListener("click", (e)=>{ e.stopPropagation(); closeTool(tool.id); });
    btnMin.addEventListener("click", (e)=>{ e.stopPropagation(); minimizeTool(tool.id); });
    btnMax.addEventListener("click", (e)=>{ e.stopPropagation(); toggleMax(tool.id); });

    makeDraggable(win, head);
    win.addEventListener("mouseup", ()=> clampToStage(win));
    win.addEventListener("mouseleave", ()=> clampToStage(win));

    return win;
  }

  function clampToStage(win){
    const rStage = stage.getBoundingClientRect();
    const rWin = win.getBoundingClientRect();
    const dockSpace = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--dockH")) + 20;

    let left = parseFloat(win.style.left || "0");
    let top = parseFloat(win.style.top || "0");

    const maxLeft = rStage.width - rWin.width - 10;
    const maxTop = rStage.height - rWin.height - dockSpace;

    if (left < 10) left = 10;
    if (top < 10) top = 10;
    if (left > maxLeft) left = Math.max(10, maxLeft);
    if (top > maxTop) top = Math.max(10, maxTop);

    win.style.left = left + "px";
    win.style.top = top + "px";
  }

  function makeDraggable(win, handle){
    let dragging = false;
    let startX=0, startY=0, startL=0, startT=0;

    handle.addEventListener("mousedown", (e)=>{
      if (e.target.closest(".sdd-w-actions")) return;
      if (win.classList.contains("max")) return;

      dragging = true;
      bringToFront(win);
      startX = e.clientX;
      startY = e.clientY;
      startL = parseFloat(win.style.left || "0");
      startT = parseFloat(win.style.top || "0");
      document.addEventListener("mousemove", onMove);
      document.addEventListener("mouseup", onUp);
    });

    function onMove(e){
      if (!dragging) return;
      const dx = e.clientX - startX;
      const dy = e.clientY - startY;
      win.style.left = (startL + dx) + "px";
      win.style.top  = (startT + dy) + "px";
    }
    function onUp(){
      if (!dragging) return;
      dragging = false;
      document.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseup", onUp);
      clampToStage(win);
    }
  }

  function closeTool(toolId){
    const w = windows.get(toolId);
    if (!w) return;
    w.el.remove();
    windows.delete(toolId);
    tileWindows();
    refreshDock();
  }

  function minimizeTool(toolId){
    const w = windows.get(toolId);
    if (!w) return;
    w.minimized = true;
    w.el.style.display = "none";
    refreshDock();
    tileWindows();
  }

  function restoreTool(toolId){
    const w = windows.get(toolId);
    if (!w) return;
    w.minimized = false;
    w.el.style.display = "flex";
    bringToFront(w.el);
    refreshDock();
    tileWindows();
  }

  function toggleMax(toolId){
    const w = windows.get(toolId);
    if (!w) return;
    w.max = !w.max;
    w.el.classList.toggle("max", w.max);
    bringToFront(w.el);
    if (!w.max) clampToStage(w.el);
    tileWindows();
  }

  function refreshDock(){
    dock.innerHTML = "";
    const minimized = Array.from(windows.entries())
      .map(([id,w]) => ({ id, w }))
      .filter(x => x.w.minimized);

    if (minimized.length === 0){
      dock.appendChild(el("div", {
        style:"opacity:.75;font-size:12px;padding:0 6px;white-space:nowrap;",
        html:"Aucun outil minimisé — le dock sert à reprendre un outil en suspend."
      }));
      return;
    }

    minimized.forEach(({id})=>{
      const tool = TOOLS.find(t=>t.id===id);
      const item = el("div", { class:"sdd-dock-item", role:"button", tabindex:"0", title:"Restaurer" }, [
        el("div", { class:"sdd-d-ico", html: tool?.icon ?? "🪄" }),
        el("div", { class:"sdd-d-name", html: tool?.name ?? id })
      ]);
      item.addEventListener("click", ()=> restoreTool(id));
      item.addEventListener("keydown",(e)=>{ if(e.key==="Enter"||e.key===" "){ e.preventDefault(); restoreTool(id); } });
      dock.appendChild(item);
    });
  }

  function tileWindows(){
    const active = Array.from(windows.values())
      .filter(w => !w.minimized && !w.max)
      .map(w => w.el);

    const n = active.length;
    if (n === 0) return;

    const rStage = stage.getBoundingClientRect();
    const dockSpace = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--dockH")) + 20;
    const pad = 10;
    const W = rStage.width - pad*2;
    const H = rStage.height - pad*2 - dockSpace;

    function setRect(win, x, y, w, h){
      win.style.left = (pad + x) + "px";
      win.style.top  = (pad + y) + "px";
      win.style.width = Math.max(280, w) + "px";
      win.style.height = Math.max(220, h) + "px";
    }

    if (n === 1){
      setRect(active[0], 0, 0, Math.min(920, W), Math.min(700, H));
      const w0 = parseFloat(active[0].style.width);
      const h0 = parseFloat(active[0].style.height);
      active[0].style.left = (pad + (W - w0)/2) + "px";
      active[0].style.top = (pad + (H - h0)/2) + "px";
      return;
    }

    if (n === 2){
      const gap = 10;
      const w = (W - gap) / 2;
      setRect(active[0], 0, 0, w, H);
      setRect(active[1], w + gap, 0, w, H);
      return;
    }

    if (n === 3){
      const gap = 10;
      const wLeft = (W * 0.58) - gap/2;
      const wRight = (W * 0.42) - gap/2;
      const hRight = (H - gap)/2;
      setRect(active[0], 0, 0, wLeft, H);
      setRect(active[1], wLeft + gap, 0, wRight, hRight);
      setRect(active[2], wLeft + gap, hRight + gap, wRight, hRight);
      return;
    }

    const cols = n <= 6 ? 2 : 3;
    const gap = 10;
    const rows = Math.ceil(n / cols);
    const cellW = (W - gap*(cols-1)) / cols;
    const cellH = (H - gap*(rows-1)) / rows;

    active.forEach((win, i)=>{
      const c = i % cols;
      const r = Math.floor(i / cols);
      setRect(win, c*(cellW+gap), r*(cellH+gap), cellW, cellH);
    });
  }

  btnCloseAll.addEventListener("click", ()=>{
    Array.from(windows.keys()).forEach(id => closeTool(id));
  });

  btnMinAll.addEventListener("click", ()=>{
    Array.from(windows.keys()).forEach(id => {
      const w = windows.get(id);
      if (w && !w.minimized) minimizeTool(id);
    });
  });

  btnArrange.addEventListener("click", ()=> tileWindows());

  // INIT
  renderTiles(TOOLS);
  refreshDock();
  applySearch("");
  window.addEventListener("resize", ()=> tileWindows());
})();
